import React, { useEffect, useState } from "react"
import { TabsComponent } from "../../../../../component/index.jsx"
import { useTranslation } from "react-i18next"
import { BlockTab } from "./tab-block/BlockTab.jsx"
import { ListAreaTab } from "./tab-block/ListAreaTab.jsx"
import { QaInspectionTab } from "./tab-block/QaInspectionTab.jsx"
import { useSubheader } from "../../../../../_metronic/layout/index.js"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { ROUTING_STATUS } from "../../../../../constants/StringConstant.js"
import { useSelector } from "react-redux"
import { stringFormatting } from "../../../../helpers/TextHelper.js"

export const DetailLandBlock = ({
  history,
  match: {
    params: { status, id }
  }
}) => {
  const { t } = useTranslation()
  const subHeader = useSubheader()
  const { Area, General } = useSelector((state) => state)
  const [data, setData] = useState({})

  useEffect(() => {
    if (Area.blockDetail) {
      setData(Area.blockDetail)
    }
  }, [Area])

  useEffect(() => {
    subHeader.setBreadcrumbs([
      {
        pathname: RoutesConstants.AREA.LIST_BLOCK(ROUTING_STATUS.STATUS_ENUM.ACTIVE),
        title: t("label_area_name")
      },
      {
        pathname: RoutesConstants.AREA.LIST_BLOCK(ROUTING_STATUS.STATUS_STRING.ACTIVE),
        title: t("label_land_block")
      },
      {
        pathname: RoutesConstants.AREA.LIST_BLOCK(
          status === ROUTING_STATUS.STATUS_STRING.ACTIVE
            ? ROUTING_STATUS.STATUS_STRING.ACTIVE
            : status
        ),
        title:
          status === ROUTING_STATUS.STATUS_STRING.ACTIVE ? t("label_active") : t("label_history")
      },
      {
        title: stringFormatting(data?.header?.block_name)
      }
    ])
    subHeader.setButton(null)
  }, [data])

  const getTabContents = () => {
    const labelList = [
      t("label_detail_block").toUpperCase(),
      t("label_list_area").toUpperCase(),
      t("label_qa_inspection").toUpperCase()
    ]
    const componentList = [
      <BlockTab
        key={0}
        id={id}
        data={data}
        loading={General?.loading}
        status={status}
        history={history}
      />,
      <ListAreaTab key={1} id={id} history={history} status={status} />,
      <QaInspectionTab key={2} id={id} status={status} />
    ]

    return {
      labels: labelList,
      contents: componentList
    }
  }

  return (
    <>
      <TabsComponent labelTab={getTabContents().labels} componentTab={getTabContents().contents} />
    </>
  )
}